module.exports = __webpack_public_path__ + "static/media/M104ws.b9ad4c44.pdf";